import secureLocalStorage from "react-secure-storage";
import React from 'react';
import Images from '../Assets/Images';
import '../Styles/UnAuthorized.scss';
import { useAuth } from '../Context/AuthContext';

const UnAuthorized = (props) => {
  const { currentUser } = useAuth();
  
  const gotoLogin = () => {
    const token = secureLocalStorage.getItem("tenantKey") || secureLocalStorage.getItem("userKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient") || "tenant";
    
    props.history.push({
      pathname: `/${loggedClient}/${token}`,
    });
  };
  
  const goBack = () => {
    // Only redirect to home if user is authenticated
    if (currentUser) {
      const token = secureLocalStorage.getItem("tenantKey") || secureLocalStorage.getItem("userKey");
      const loggedClient = secureLocalStorage.getItem("loggedClient") || "tenant";
      props.history.push({
        pathname: `/${loggedClient}/${token}/home/main`,
      });
    } else {
      // If not authenticated, redirect to login
      gotoLogin();
    }
  };
  
  return (
    <div className="unauthCont">
      <img src={Images.UNAUTH} width="100" alt="Unauthorized" />
      <h3>Access Denied</h3>
      <p>You don't have permission to access this page.</p>
      {currentUser ? (
        <button onClick={goBack}>Go Back</button>
      ) : (
        <button onClick={gotoLogin}>Go to Login</button>
      )}
    </div>
  );
};

export default UnAuthorized;
